import styled from 'styled-components';
import themeGet from '@styled-system/theme-get';

import Container from '../../../Core/Container';

export const StyledContainer = styled(Container)`
  display: flex;
  gap: 1.5rem;
  flex-direction: column;

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    flex-direction: row;
  }
`;
